import { Options } from '@components/Entity/options'

export default new Options({
  type: '*postTemplate.PostTemplate',
  entityRouteName: 'post_templates',
  routeName: 'post_templates',
  viewName: 'PostTemplates',
  bundleType: '*postTemplate.PostTemplate',
  formSuccessMessage: 'Запись изменена.',
  deleteFormSuccessMessage: 'Запись удалена.',
  deleteFormTitle: 'Уверены, что хотите удалить эту запись?',
  unDeleteFormTitle: 'Уверены, что хотите восстановить эту запись?',
  documentTitle: 'Справочник постов',
  config: {
    adapter: 'PostTemplateAdapter'
  }
})
